<template>
<div class="page repairs">
  <h1>Onderhoud & herstellingen</h1>
</div>
</template>

<script>
export default {
name: "Repairs"
}
</script>
